import { connect } from 'react-redux';
import GeofenceLocations from './GeofenceLocations';
import {
  getGeofenceLocations,
  deleteGeofenceLocation,
  addGeofenceLocation,
  updateGeofenceLocation,
} from './geofenceLocationsActions';
import { getOfficesShortList } from '../Offices/officesActions';

const mapStateToProps = state => ({
  // Map your state here
  geofenceLocations: state.geofenceLocations.geofenceLocations,
  geofenceLocationsLoading: state.geofenceLocations.loading,
  deleteGeofenceLocationLoading: state.geofenceLocations.deleteGeofenceLocationLoading,
  addGeofenceLocationLoading: state.geofenceLocations.addGeofenceLocationLoading,
  createdGeofenceLocationInfo: state.geofenceLocations.createdGeofenceLocationInfo,
  officesShortList: state.office.officesShortList,
  updateGeofenceLocationLoading: state.geofenceLocations.updateGeofenceLocationLoading,
});

const mapDispatchToProps = dispatch => ({
  getGeofenceLocations: params => dispatch(getGeofenceLocations(params)),
  deleteGeofenceLocation: params => dispatch(deleteGeofenceLocation(params)),
  addGeofenceLocation: params => dispatch(addGeofenceLocation(params)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  updateGeofenceLocation: params => dispatch(updateGeofenceLocation(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GeofenceLocations);